import styled from 'styled-components'

import { TransactionsStatusFilter } from './transactions-status-filter'
import { TransactionsTypeFilter } from './transactions-type-filter'

import type { UserTransactionsModel } from '../../atoms'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  model: UserTransactionsModel
} & ClassNameProps

export const TransactionsFilters: React.FC<Props> = ({ model, className }) => {
  return (
    <Root className={className}>
      <TransactionsTypeFilter model={model} />
      <TransactionsStatusFilter model={model} />
    </Root>
  )
}

const Root = styled.div`
  background: var(--background-2);
  border-top: 1px solid var(--background-3);
  height: 31px;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;

  padding-inline: 6px;
`
